import { CanvasChildrenProps } from "../CanvasContainer";
import ChannelLine from "./ChannelLine";
import { Fragment } from "react";
import ChannelParabola from "./ChannelParabola";

type TechnologyChannelListProps = {
  channelList: { centralFrequencyHz: string, bandwidth: string } [],
  offset: number,
  canvasWidthInHz: number,
  startFrequency: number,
} & CanvasChildrenProps;

const TechnologyChannelList = ({
  channelList,
  offset,
  containerWidth,
  canvasWidthInHz,
  startFrequency,
}: TechnologyChannelListProps) => {
  if (!containerWidth) {
    return null;
  }

  return (
    <g className="channelList">
      {
        channelList.map((channel) => {
          return (
            <Fragment
              key={channel.centralFrequencyHz}
            >
              <ChannelLine
                channel={channel}
                offsetY={offset}
                containerWidth={containerWidth}
                canvasWidthInHz={canvasWidthInHz}
                startFrequency={startFrequency}
              />
              <ChannelParabola
                channel={channel}
                offsetY={offset}
                containerWidth={containerWidth}
                canvasWidthInHz={canvasWidthInHz}
                startFrequency={startFrequency}
              />
            </Fragment>
          )
        })
      }
    </g>
  )
}

export default TechnologyChannelList;